import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Branding, BrandingEffective, LogoVariant } from '@raptor-fe/core';
import { ServiceUtils } from '../service-utils/service-utils';

@Injectable({
    providedIn: 'root',
})
export class BrandingService {
    private readonly http = inject(HttpClient);
    private readonly serviceUtils = inject(ServiceUtils);

    getTenantBranding(tenantId: string): Observable<Branding> {
        return this.http.get<Branding>(this.serviceUtils.getBaseUrl('branding', tenantId));
    }

    getBranchBranding(tenantId: string, branchId: string): Observable<Branding> {
        return this.http.get<Branding>(this.serviceUtils.getBaseUrl('branding', tenantId) + `/branch/${branchId}`);
    }

    getEffectiveBranding(tenantId: string, branchId: string): Observable<BrandingEffective> {
        return this.http.get<BrandingEffective>(this.serviceUtils.getBaseUrl('branding', tenantId) + `/effective/${branchId}`);
    }

    upsertTenantBranding(tenantId: string, input: Partial<Branding>): Observable<Branding> {
        return this.http.put<Branding>(this.serviceUtils.getBaseUrl('branding', tenantId), input);
    }

    upsertBranchBranding(tenantId: string, branchId: string, input: Partial<Branding>): Observable<Branding> {
        return this.http.put<Branding>(this.serviceUtils.getBaseUrl('branding', tenantId) + `/branch/${branchId}`, input);
    }

    removeBranchBranding(tenantId: string, branchId: string): Observable<void> {
        return this.http.delete<void>(this.serviceUtils.getBaseUrl('branding', tenantId) + `/branch/${branchId}`);
    }

    uploadTenantLogo(tenantId: string, variant: LogoVariant, file: File): Observable<Branding> {
        const formData = new FormData();
        formData.append('file', file, file.name);
        return this.http.post<Branding>(this.serviceUtils.getBaseUrl('branding', tenantId) + `/logo/${variant}`, formData);
    }

    uploadBranchLogo(tenantId: string, branchId: string, variant: LogoVariant, file: File): Observable<Branding> {
        const formData = new FormData();
        formData.append('file', file, file.name);
        return this.http.post<Branding>(this.serviceUtils.getBaseUrl('branding', tenantId) + `/branch/${branchId}/logo/${variant}`, formData);
    }

    clearCache(tenantId: string): Observable<void> {
        return this.http.post<void>(this.serviceUtils.getBaseUrl('branding', tenantId) + '/cache/clear', null);
    }
}
